module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-waterheating.png?3bb2287eeec37e2462abdbd60f3ffc26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-waterheating.png
// module id = 1051
// module chunks = 1